/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximální počet povolených souborů je ${i.maxFileCount}`
};

const da_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Maksimalt antal filer er ${i.maxFileCount}`
};

const de_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Die maximale Anzahl an Dateien beträgt ${i.maxFileCount}`
};

const en_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `The maximum number of files allowed is ${i.maxFileCount}`
};

const es_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `El número máximo de archivos permitidos es ${i.maxFileCount}`
};

const fr_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Le nombre maximum de fichiers autorisés est de ${i.maxFileCount}`
};

const hu_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `A fájlok maximális száma ${i.maxFileCount}`
};

const it_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Il numero massimo di file consentiti è ${i.maxFileCount}`
};

const nl_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Het maximaal toegestane aantal bestanden is ${i.maxFileCount}`
};

const pl_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Maksymalna liczba plików to ${i.maxFileCount}`
};

const pt_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `O número máximo de arquivos permitidos é ${i.maxFileCount}`
};

const sv_contact_alert_max_file_count = /** @type {(inputs: { maxFileCount: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximalt antal filer är ${i.maxFileCount}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ maxFileCount: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_alert_max_file_count = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_alert_max_file_count(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_alert_max_file_count", locale)
	if (locale === "cs") return cs_contact_alert_max_file_count(inputs)
	if (locale === "da") return da_contact_alert_max_file_count(inputs)
	if (locale === "de") return de_contact_alert_max_file_count(inputs)
	if (locale === "en") return en_contact_alert_max_file_count(inputs)
	if (locale === "es") return es_contact_alert_max_file_count(inputs)
	if (locale === "fr") return fr_contact_alert_max_file_count(inputs)
	if (locale === "hu") return hu_contact_alert_max_file_count(inputs)
	if (locale === "it") return it_contact_alert_max_file_count(inputs)
	if (locale === "nl") return nl_contact_alert_max_file_count(inputs)
	if (locale === "pl") return pl_contact_alert_max_file_count(inputs)
	if (locale === "pt") return pt_contact_alert_max_file_count(inputs)
	return sv_contact_alert_max_file_count(inputs)
};
export { contact_alert_max_file_count as "contact.alert.max_file_count" }